import React, { useContext, useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import LC from 'locale-currency'

import Button from '@react/react-spectrum/Button'
import Alert from '@react/react-spectrum/Alert'
import Wait from '@react/react-spectrum/Wait'

import { RootContext } from '../../root/RootContext'
import { useCurrentUserAndProject } from '../../data/hooks'
import { PATHS } from '../../config/constants'
import { sendAppLaunchEvent, setInDataLayer } from '../../services/analytics'

import Header from '../../fragments/Header/Header'
import Home from '../Home'

import './App.scss'

export default function App({ projectID, entityIdNS, entityId }) {
  const { project, setRootState } = useContext(RootContext)

  const { loading, error, data } = useCurrentUserAndProject({
    variables: { projectId: projectID },
  })

  //set direct route access to skip profile search
  useEffect(() => {
    setRootState(s => ({ ...s, dr: { entityId, entityIdNS } }))
  }, [entityId, entityIdNS])

  // set currentUser and project in RootContext
  useEffect(() => {
    if (data) {
      const project = data?.project?.content
      setRootState(s => ({ ...s, currentUser: data?.me, project }))
      // Send App Launch event to Analytics
      const projectDetails = {
        id: project?.meta?.id,
        title: project?.meta?.title,
        template: project?.meta?.template,
        locale: project?.meta?.locale,
        currency: LC.getCurrency(project?.meta?.locale || 'en-US'),
      }
      setInDataLayer({ project: projectDetails })
      sendAppLaunchEvent(data?.me?.id, projectDetails)
    }
  }, [data])

  if (loading) {
    return (
      <div className='app-wrapper'>
        <div className='wait-wrapper'>
          <Wait centered size='L' />
        </div>
      </div>
    )
  }

  if (error) {
    if (error.networkError && error.networkError.statusCode === 401) {
      return (
        <div className='app-wrapper'>
          <div className='error-wrapper'>
            <Alert variant='info' header='Welcome'>
              We need to sign you in first. Redirecting...
            </Alert>
          </div>
        </div>
      )
    } else {
      return (
        <div className='app-wrapper'>
          <div className='error-wrapper'>
            <Alert variant='error' header='Error'>
              {error.message}
            </Alert>
          </div>
        </div>
      )
    }
  }

  if (!project) {
    return (
      <div className='app-wrapper'>
        <div className='error-wrapper'>
          <Alert variant='error' header='Error'>
            Selected project Id does not exist <br />
            <br />
            <Button
              variant='cta'
              onClick={() => {
                window.location = `/`
              }}
            >
              Open Experience Builder
            </Button>
          </Alert>
        </div>
      </div>
    )
  }

  const launchId = project?.integrations?.launch?.appId
  if (launchId) {
    let launchJSONUrl = 'https://assets.adobedtm.com/' + launchId + '.min.js'
    if (!document.getElementById('launchScript')) {
      var scr = document.createElement('script'),
        head = document.head || document.getElementsByTagName('head')[0]
      scr.src = launchJSONUrl
      scr.id = 'launchScript'
      scr.defer = true
      head.insertBefore(scr, head.firstChild)
    }
  }

  return (
    <div className='app-wrapper'>
      <Header />
      <div className='app-content'>
        <Switch>
          <Route path={PATHS.HOME} component={Home} />
        </Switch>
      </div>
    </div>
  )
}
